import './index.css'

const Header = () => (
  <nav className="nav-header">
    <div className="nav-content">
      <p className="website-logo">NVS</p>
      <ul className="nav-menu">
        <li>
          <a
            rel="noreferrer"
            href="https://www.linkedin.com/in/vsn99"
            target="_blank"
          >
            <img
              className="social-network-img"
              src="https://assets.ccbp.in/frontend/react-js/projects-linkedin-img.png"
              alt="Linked In"
            />
          </a>
        </li>
        <li>
          <a
            href="https://github.com/siva5511"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="social-network-img"
              src="https://assets.ccbp.in/frontend/react-js/projects-github-img.png"
              alt="Git Hub"
            />
          </a>
        </li>
        <li>
          <a
            rel="noreferrer"
            href="https://twitter.com/Venkatasiva555"
            target="_blank"
          >
            <img
              className="social-network-img"
              src="https://assets.ccbp.in/frontend/react-js/projects-twitter-img.png"
              alt="Twitter"
            />
          </a>
        </li>
      </ul>
    </div>
  </nav>
)

export default Header
